import { createContext } from "react";

import { IProgressBarContext } from "@krea/customer-features/shared-components/app/progress-bar/context";

export const MenuContext = createContext<IProgressBarContext>({
  toggleMenu: () => {},
  showSteps: () => {},
  stepsIsVisible: false,
  openApplicationSelector: () => {},
});
